import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, FormGroup, Label, Input, Col, Form, Button, Popover, PopoverBody} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import {Utils} from "../../../utils/utils";
import {EMPLOYEES_COUNT_VALUES, ORGANIZATION_AVAILABLE_FLAGS, ORGANIZATION_TYPES} from "../../../constants/constants";
import './OrgDetails.css';
import PageNotFoundComponent from '../../commonComponents/pageNotFoundComponent/PageNotFoundComponent.container';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import OrgCertificates from '../certificatesManagement/orgCertificates/OrgCertificates.container';
import DomainInput from "../../commonComponents/domainInput/DomainInput";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {SUB_ROLES} from "../../../reducers/account/role";

const PATH_BY_FIELD_NAME = {
    'hasIVs': 'orgs.has_accreditation_groups_label',
    'verifiesIdentities': 'orgs.verifies_identities_label',
    'providesMoocCertificates': 'orgs.provides_mooc_certificates_label',
};

const ORG_EDIT_SUCCESS_MESSAGE = 'edit_org.org_edit_success_message';
const ANCHOR_EDIT_SUCCESS_MESSAGE = 'edit_org.anchor_edit_success_message';
const BAVA_ADD_SUCCESS_MESSAGE = 'edit_org.bava_set_success_message';
const BAVA_REMOVE_SUCCESS_MESSAGE = 'edit_org.bava_removed_success_message';

const requiredSelectFields = ['orgCountry'];

class OrgDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orgType: '',
            orgName: '',
            orgDomain: '',
            orgVatNumber: '',
            companyCode: '',
            orgContinent: this.props.continentCode,
            orgEmployeeCount: 'UNKNOWN',
            orgCountry: '',
            orgCity: '',
            orgPostal: '',
            orgStreet: '',
            orgStreetNumber: '',
            orgBusNumber: '',
            anchorFirstName: '',
            anchorLastName: '',
            anchorEmail: '',
            hasIVs: true,
            providesMoocCertificates: false,
            isBava: false,
            successMessage: '',
            requiredFieldError: null,
            popoverOpen: null
        };
    }

    componentWillMount() {
        this.props.onMount(this.props.id);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.orgContinent !== nextProps.continentCode) {
            this.setState({orgContinent: nextProps.continentCode})
        }
        if (!_.isNil(nextProps.data) && (!_.isEqual(nextProps.data, this.props.data))) {
            this.setState({...nextProps.data});
            this.props.onSetContinent(nextProps.data.orgContinent);
        }
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    render() {
        if (this.props.fetchingError) {
            return <PageNotFoundComponent/>;
        }

        if (this.props.loading && _.isNil(this.props.data)) {
            return (
                <div className="org-details-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        return (
            <div className="org-details-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, this.state.successMessage)}
                >
                    <div className="org-details-form">
                        <BackButtonComponent path='/organizations'
                                             label={_.get(this.props.translation, 'edit_org.back_button')}/>
                        <h4 className="page-label">{_.get(this.props.translation, sharedLabelsPath[this.props.labelPath])}: {_.isNil(this.props.data) ? '' : this.props.data.orgName}</h4>
                        <Form onSubmit={this.onOrgEdit}>
                            <h5 className="org-details-subtitle olive-green">{_.get(this.props.translation, 'orgs.org_label')}</h5>
                            {this.renderOrganizationDataFormGroups()}
                            <h6>{_.get(this.props.translation, 'orgs.address_label')}</h6>
                            {this.renderOrganizationAddressFormGroup()}
                            <h6 className='checkbox-group-label'>{_.get(this.props.translation, 'orgs.permissions_label')}</h6>
                            <div className='checkbox-group-container'>
                                {this.renderPermissionsFormGroup()}
                            </div>
                            <div className="buttons-group">
                                <Button type="submit"
                                        disabled={this.saveButtonDisabled('orgDetails')}
                                        className="olive-green-btn">{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                            </div>
                        </Form>
                        {this.renderBavaForm()}
                        <Form onSubmit={this.onAnchorEdit}>
                            <h5 className="org-details-subtitle olive-green">{_.get(this.props.translation, 'orgs.anchor_label')}</h5>
                            {this.renderAnchorFormGroups()}
                            <div className="buttons-group">
                                <Button type="submit"
                                        title={_.get(this.props.translation, 'edit_org.edit_anchor_alert')}
                                        disabled={this.saveButtonDisabled('anchorDetails')}
                                        className="olive-green-btn">{_.get(this.props.translation, 'edit_org.edit_anchor_button')}</Button>
                            </div>
                        </Form>
                        {this.renderOrgCertificatesForm()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderBavaForm = () => {
        if (this.props.subRoles && !this.props.subRoles.includes(SUB_ROLES.ROOT)) {
            return null;
        }

        return (
            <Form onSubmit={this.onBavaEdit}>
                <h5 className="org-details-subtitle olive-green">{_.get(this.props.translation, 'edit_org.bava_label')}</h5>
                <div className='checkbox-group-container'>
                    {this.renderBavaFormGroup()}
                </div>
                <div className="buttons-group">
                    <Button type="submit"
                            disabled={this.saveButtonDisabled('orgBava')}
                            className="olive-green-btn">{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </Form>
        )
    }

    renderOrgCertificatesForm = () => {
        if (this.props.subRoles && !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA)) {
            return null;
        }

        return (
            <Form>
                <h5 className="org-details-subtitle olive-green">{_.get(this.props.translation, 'certificate.label')}</h5>
                <OrgCertificates orgId={this.props.id}/>
            </Form>
        );
    };

    saveButtonDisabled = (type) => {
        if (_.isNull(this.props.data)) {
            return true;
        }

        let keysList = [];
        switch (type) {
            case 'orgDetails':
                keysList = [
                    'orgType',
                    'orgName',
                    'orgDomain',
                    'orgVatNumber',
                    'companyCode',
                    'orgEmployeeCount',
                    'orgCountry',
                    'orgCity',
                    'orgPostal',
                    'orgStreet',
                    ...ORGANIZATION_AVAILABLE_FLAGS
                ];
                break;
            case 'orgBava':
                keysList = ['isBava'];
                break;
            case 'anchorDetails':
                keysList = [
                    'anchorEmail',
                    'anchorFirstName',
                    'anchorLastName'
                ];
                break;
            default:
                break;
        }


        return _.every(keysList, fieldKey => this.state[fieldKey] === this.props.data[fieldKey]);
    };

    renderOrganizationDataFormGroups = () => {
        let paramsList = [
            {
                value: "orgType",
                title: _.get(this.props.translation, 'orgs.org_type_label'),
                type: 'select',
                content: Utils.getOptions(
                    _.map(ORGANIZATION_TYPES, value => ({
                        code: value.code,
                        name: _.get(this.props.translation, value.name)
                    }))
                ),
                isRequired: true,
                placeholder: _.get(this.props.translation, 'register_org.org_type_placeholder'),
                onChange: this.handleChangeSelect('orgType')
            },
            {
                value: "orgName",
                title: _.get(this.props.translation, 'orgs.name_label') + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.name_label')
            },
            {
                value: "orgDomain",
                title: _.get(this.props.translation, sharedLabelsPath.domain_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.domain_label)
            },
            {
                value: "orgVatNumber",
                title: _.get(this.props.translation, 'orgs.vat_number_label'),
                isRequired: false,
                placeholder: _.get(this.props.translation, 'orgs.vat_number_label')
            },
            {
                value: "companyCode",
                title: _.get(this.props.translation, 'orgs.company_code_label'),
                isRequired: false,
                placeholder: _.get(this.props.translation, 'orgs.company_code_label')
            },
            {
                value: 'orgEmployeeCount',
                title: _.get(this.props.translation, sharedLabelsPath.employee_count_label),
                type: 'select',
                content: Utils.getOptions(_.map(EMPLOYEES_COUNT_VALUES, value => ({
                    code: value.code,
                    name: _.get(this.props.translation, value.name) || value.name
                }))),
                isRequired: true,
                onChange: this.handleChangeSelect('orgEmployeeCount')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderOrganizationAddressFormGroup = () => {
        let paramsList = [
            {
                value: "orgContinent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                onChange: this.handleChangeContinent,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                isDisabled: !this.props.continents,
                isRequired: true
            },
            {
                value: "orgCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                onChange: this.handleChangeSelect('orgCountry'),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder:_.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isRequired: true,
                isDisabled: !this.props.countries
            },
            {
                value: "orgCity",
                title: _.get(this.props.translation, 'orgs.city_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.city_label')
            },
            {
                value: "orgPostal",
                title: _.get(this.props.translation, 'orgs.postal_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.postal_label')
            },
            {
                value: "orgStreet",
                title: _.get(this.props.translation, 'orgs.street_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.street_label')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderAnchorFormGroups = () => {
        let paramsList = [
            {
                value: "anchorEmail",
                title: _.get(this.props.translation, sharedLabelsPath.email_label) + "*",
                type: "email",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "anchorFirstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label),
            },
            {
                value: "anchorLastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderCheckboxes = () => {
        return _.map(ORGANIZATION_AVAILABLE_FLAGS, flag => (
            <FormGroup key={flag} className='checkbox-form-group'>
                <Row className='checkbox-container'>
                    <Label className='checkbox-label'>
                        <Input type="checkbox" checked={this.state[flag]}
                               onChange={this.toggleCheckbox(flag)}/>
                        {_.get(this.props.translation, PATH_BY_FIELD_NAME[flag])}
                    </Label>
                </Row>
            </FormGroup>
        ))
    };

    renderPermissionsFormGroup = () => {
        let paramsList = _.map(ORGANIZATION_AVAILABLE_FLAGS, flag => ({
            value: flag,
            title: _.get(this.props.translation, PATH_BY_FIELD_NAME[flag])
        }));

        return [..._.map(paramsList, this.getCheckboxFormGroup)];
    }

    renderBavaFormGroup = () => {
        let params = {
            value: 'isBava',
            title: _.get(this.props.translation, 'edit_org.bava_organization_label')
        };

        return this.getCheckboxFormGroup(params);
    }

    getCheckboxFormGroup = (params) => {
        return (
          <FormGroup key={params.value} className='checkbox-form-group'>
              <Row className='checkbox-container'>
                  <Label className='checkbox-label'>
                      <Input type="checkbox" checked={this.state[params.value]}
                             disabled={params.isDisabled}
                             onChange={this.toggleCheckbox(params.value)}/>
                      {params.title}
                  </Label>
              </Row>
          </FormGroup>
        )
    }

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (params.value === 'orgDomain') {
            return this.getOrganizationDomainFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);

        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getOrganizationDomainFormGroup = (params) => {
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <DomainInput id={id}
                                 value={this.state[params.value]}
                                 onChange={this.handleChangeDomainInput}
                                 placeholder={params.placeholder || params.title}
                                 disabled={params.isDisabled}
                                 required={params.isRequired}/>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderPopover = (params) => {
        let hintText = '';
        let id = 'validate-org-';

        switch (params.value) {
            case 'orgDomain':
                id += 'domain-hint-container';
                hintText = _.get(this.props.translation, 'register_org.domain_hint');
                break;
            case 'companyCode':
                id += 'company-code-hint-container';
                hintText = _.get(this.props.translation, 'register_org.company_code_hint');
                break;
            default:
                return;
        }

        return (
            <div className="validate-org-hint-container">
                <span id={id} className='validate-org-icon-container' onClick={this.togglePopover}>
                    <IconContainer icon='question_mark' title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                </span>
                <Popover placement="bottom" isOpen={this.state.popoverOpen === params.value} target={id}
                         toggle={this.togglePopover(params.value)}>
                    <PopoverBody>
                        {hintText}
                    </PopoverBody>
                </Popover>
            </div>
        );
    };

    togglePopover = (type) => () => {
        if (this.state.popoverOpen === type) {
            this.setState({popoverOpen: null});
        } else {
            this.setState({popoverOpen: type});
        }
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeDomainInput = (data) => {
        this.setState({orgDomain: data});
    };

    toggleCheckbox = (fieldKey) => () => {
        this.setState({[fieldKey]: !this.state[fieldKey]})
    };

    handleChangeContinent = (selectedOption) => {
        this.props.onSetContinent(selectedOption.value);
        this.setState({orgCountry: ''});
    };

    onAnchorEdit = (e) => {
        e.preventDefault();

        let data = {
            email: this.state.anchorEmail,
            identityAlias: {
                firstName: this.state.anchorFirstName,
                lastName: this.state.anchorLastName,
                countryCode: this.state.orgCountry
            }
        };

        this.setState({successMessage: ANCHOR_EDIT_SUCCESS_MESSAGE});
        this.props.onAnchorEdit(this.props.id, data);
    };

    onOrgEdit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let data = {
            type: this.state.orgType,
            name: this.state.orgName,
            domain: this.state.orgDomain,
            address: {
                countryCode: this.state.orgCountry,
                city: this.state.orgCity,
                postal: this.state.orgPostal,
                street: this.state.orgStreet
            },
            vatNumber: this.state.orgVatNumber,
            companyCode: this.state.companyCode,
            anchor: {
                email: this.state.anchorEmail,
                identityAlias: {
                    firstName: this.state.anchorFirstName,
                    lastName: this.state.anchorLastName
                }
            },
            hasIVs: this.state.hasIVs,
            verifiesIdentities: this.state.hasIVs,
            providesMoocCertificates: this.state.providesMoocCertificates,
            employeeCount: this.state.orgEmployeeCount,
            validated: true
        };

        this.setState({successMessage: ORG_EDIT_SUCCESS_MESSAGE});
        this.props.onOrgEdit(this.props.id, data);
    };

    onBavaEdit = (e) => {
        e.preventDefault();

        if (this.state.isBava) {
            this.setState({successMessage: BAVA_ADD_SUCCESS_MESSAGE});
            this.props.onMarkOrgAsBava(this.props.id);
        } else {
            this.setState({successMessage: BAVA_REMOVE_SUCCESS_MESSAGE});
            this.props.onRemoveOrgBavaFlag();
        }
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

OrgDetails.propTypes = {
    id: PropTypes.string,
    labelPath: PropTypes.string,
    data: PropTypes.object,
    loading: PropTypes.bool,
    fetchingError: PropTypes.string,
    translation: PropTypes.object,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    subRoles: PropTypes.array,
    onSetContinent: PropTypes.func,
    onOrgEdit: PropTypes.func,
    onAnchorEdit: PropTypes.func,
    onMarkOrgAsBava: PropTypes.func,
    onRemoveOrgBavaFlag: PropTypes.func,
    onMount: PropTypes.func,
    onUnmount: PropTypes.func
};

export default OrgDetails;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgDetails/OrgDetails.js